module.exports = __webpack_public_path__ + "img/kba-export-not-exported.6dc31529.svg";